<template>
  <div>
    <v-select
      v-model="profession"
      :items="professions"
      item-text="name"
      item-value="id"
      outlined
      label="Kopiera till yrke"
      return-object
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import filter from 'lodash/filter'

export default {
  name: 'TheProfessionList',

  props: {
    selectedProfession: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    professions: []
  }),

  created() {
    this.professions = filter(this.basicProfessions, ['isApplicationProfession', true])
  },

  computed: {
    ...mapGetters('basic', ['basicProfessions']),

    profession: {
      get() {
        return this.selectedProfession
      },
      set(value) {
        this.$emit('on-change', value)
      }
    }
  }
}
</script>